import React from 'react';
import {
  Menu,
  Button,
  Dropdown,
  Input,
  Segment,
  Grid,
} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import AirlineDropdown from '../dropdowns/AirlineDropdown';
import StatesDropdown from '../dropdowns/StatesDropdown';
import FlightNumberDropdown from '../dropdowns/FlightNumberDropdown';
import SelectedFiltersLabels from '../SelectedFiltersLabels';
import PassengerEmailDropdown from '../dropdowns/PassengerEmailDropdown';
import withCountriesOptions from '../HOC/withCountriesOptions';
import { disturbanceOptions } from '../../options/disturbanceOptions';

class ClaimsFilters extends React.Component {
  state = {};

  handleInputChange = (e, { name, value }) => this.setState({ [name]: value });

  handleEnterPress = (e) => {
    const { name } = e.target;
    if (e.key === 'Enter')
      this.props.onFilterAdd.call(this, name, e, { value: this.state[name] });
  };

  handleDateChange = (date) =>
    this.props.onDateFilterChange(date, 'flightDate');

  render = () => {
    const {
      countriesOptions,
      loading,
      onFilterAdd,
      onApply,
      onClear,
      filters,
    } = this.props;
    return (
      <Segment basic>
        <Menu.Item>
          <Menu.Header>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column verticalAlign="middle">Filter</Grid.Column>
                <Grid.Column textAlign="right">
                  <Button basic size="mini" color="red" onClick={onClear}>
                    Clear Filters
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Menu.Header>
          <Menu.Menu>
            <Menu.Item>Claim Status</Menu.Item>
            <Menu.Item>
              <SelectedFiltersLabels filter="crmStates" {...this.props} />
              <StatesDropdown
                value={null}
                onChange={onFilterAdd.bind(this, 'crmStates')}
              />
            </Menu.Item>
            <Menu.Item>Airline</Menu.Item>
            <Menu.Item>
              <SelectedFiltersLabels filter="airlineNames" {...this.props} />
              <AirlineDropdown
                onChange={onFilterAdd.bind(this, 'airlineNames')}
                optionsValue="name"
                value={null}
              />
            </Menu.Item>
            <Menu.Item>Flight number</Menu.Item>
            <Menu.Item>
              <SelectedFiltersLabels filter="flightNumbers" {...this.props} />
              <FlightNumberDropdown
                value={null}
                onChange={onFilterAdd.bind(this, 'flightNumbers')}
              />
            </Menu.Item>
            <Menu.Item>Country</Menu.Item>
            <Menu.Item>
              <SelectedFiltersLabels filter="countryNames" {...this.props} />
              <Dropdown
                fluid
                search
                selection
                options={countriesOptions}
                value={null}
                onChange={onFilterAdd.bind(this, 'countryNames')}
                loading={loading}
              />
            </Menu.Item>
            <Menu.Item>Type of Disturbance</Menu.Item>
            <Menu.Item>
              <SelectedFiltersLabels filter="reasons" {...this.props} />
              <Dropdown
                fluid
                search
                selection
                options={disturbanceOptions}
                onChange={onFilterAdd.bind(this, 'reasons')}
                value={null}
              />
            </Menu.Item>
            <Menu.Item>Flight date</Menu.Item>
            <Menu.Item className="c-DatePicker__wrapper c-DatePicker__wrapper--filters">
              <DatePicker
                dateFormat="DD/MM/YYYY"
                selected={filters.flightDate && moment(filters.flightDate)}
                onChange={this.handleDateChange}
                isClearable={true}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                customInput={<Input style={{ width: '100%' }} />}
              />
            </Menu.Item>
            <Menu.Item>PAX email address</Menu.Item>
            <Menu.Item>
              <SelectedFiltersLabels filter="passengerEmails" {...this.props} />
              <PassengerEmailDropdown
                upward
                value={null}
                onChange={onFilterAdd.bind(this, 'passengerEmails')}
              />
            </Menu.Item>
            <Menu.Item>PAX Full Name</Menu.Item>
            <Menu.Item>
              <SelectedFiltersLabels
                filter="passengerTicketsFullNames"
                {...this.props}
              />
              <Input
                name="passengerTicketsFullNames"
                onChange={this.handleInputChange}
                onKeyPress={this.handleEnterPress}
              />
            </Menu.Item>
            <Menu.Item>ID</Menu.Item>
            <Menu.Item>
              <SelectedFiltersLabels filter="ids" {...this.props} />
              <Input
                name="ids"
                onChange={this.handleInputChange}
                onKeyPress={this.handleEnterPress}
              />
            </Menu.Item>
            <Menu.Item style={{ textAlign: 'center' }}>
              <Button primary onClick={onApply}>
                Apply
              </Button>
            </Menu.Item>
          </Menu.Menu>
        </Menu.Item>
      </Segment>
    );
  };
}

export default withCountriesOptions(ClaimsFilters);



// WEBPACK FOOTER //
// ./src/component/ClaimsListPage/ClaimsFilters.js